import React, { useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import "../assets/css/styles.table.css"
import '../assets/additional-css/react-select.css';
//for table
import Box from '@mui/material/Box';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import {apiUrl} from '../pages/UrlParam'; 
import AxiosFetchData from '../pages/AxiosFetchData';
 
//import ApexChart from '../assets/apexchart'
//import ApexCharts from 'apexcharts'
//import { lazy } from 'react';
// import Donut from './Piechart';
 import Highcharts from 'highcharts';
 import ApexChart from 'apexcharts';
import { auto, right } from '@popperjs/core';
import garis1 from '../assets/img/garis1.jpg';
import garis2 from '../assets/img/garis2.jpg';
import garis3 from '../assets/img/garis3.jpg';
import startgaris1 from '../assets/img/startgaris1.jpg';
import startgaris2 from '../assets/img/startgaris2.jpg';
import startgaris3 from '../assets/img/startgaris3.jpg';
import endgaris1 from '../assets/img/endgaris1.jpg';
import endgaris2 from '../assets/img/endgaris2.jpg';
import endgaris3 from '../assets/img/endgaris3.jpg';
import VirtualizedSelect from 'react-virtualized-select';
import Helper from '../pages/Helper'
export const useProjectDashboardHook = () => {
    const [projectCount, setProjectCount] = useState(0);
      const [clientCount, setClientCount] = useState(0);
      const [anggaran, setAnggaran] = useState(0);
      const [anggaranTersisa, setAnggaranTersisa] = useState(0);
      const [faktur, setFaktur] = useState(0);
      const [taskCount, setTaskCount] = useState(0);
      const [taskSelesaiCount, setTaskSelesaiCount] = useState(0);
      const [jamRencana, setJamRencana] = useState(0);
      const Navigate = useNavigate();
      const [rows, setRows] = useState([]);
      const [rowNumber, setRowNumber] = useState([]);
      const [chart2, setChart2] = useState({});
      const [riskMatrix, setRiskMatrix] = useState({});
      const [projectList, setProjectList] = useState([]);
      const [selectedOptionProject,setSelectedOptionProject] = useState('');
      const [tugasSelesai,setTugasSelesai] = useState('');
      const [tugas,setTugas] = useState('');
      const [milestones,setMilestones] = useState('');
      const [milestonesSelesai,setMilestonesSelesai] = useState('');
      const [tanggalMulai,setTanggalMulai] = useState('');
      const [tanggalSelesai,setTanggalSelesai] = useState('');
      const [status,setStatus] = useState('');
      const [client,setClient] = useState('');
      const [startEndProject,setStartEndProject] = useState([]);
      const [message,setmessage] = useState('');
      const [chartData, setChartData] = useState([])
      const [pageChart6, setPageChart6] = useState(0)
      const [pageChart7, setPageChart7] = useState(0)
      const [roleAccess, setRoleAccess] = useState('');

    useEffect(() => {
        axios.get(`${apiUrl}/api/GetProjek`)
        .then((response) => {
            setSelectedOptionProject(response.data[0].id);
            GetData(response.data[0].id);
        })
        .catch((error) => {
          console.error('Error fetching category data:', error);
        });
      
    }, []);
    
    
    const refreshChart = () => {
        GetData(selectedOptionProject);
    }
    
    const GetChart1 = (data) => {
        var options = {
            series: [parseFloat(data.length > 0 ? data[0].rata_kemajuan : 0)],
            chart: {
            type: 'radialBar',
            offsetY: -20,
            sparkline: {
              enabled: true
            },
            height:250
          },
          plotOptions: {
            radialBar: {
              startAngle: -90,
              endAngle: 90,
              track: {
                background: "#e7e7e7",
                strokeWidth: '97%',
                margin: 5, // margin is in pixels
                dropShadow: {
                  enabled: true,
                  top: 2,
                  left: 0,
                  color: '#999',
                  opacity: 1,
                  blur: 2
                }
              },
              dataLabels: {
                name: {
                  show: false
                },
                value: {
                  offsetY: -2,
                  fontSize: '22px'
                }
              }
            }
          },
          grid: {
            padding: {
              top: -10
            }
          },
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'light',
              shadeIntensity: 0.4,
              inverseColors: false,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 50, 53, 91]
            },
          },
          labels: ['Average Results'],
          };
          document.querySelector("#chart1").innerHTML = "";
          var chart = new ApexChart(document.querySelector("#chart1"), options);
          chart.render();
         
    }
    
    const GetChart2 = (data) => {
        var number = (data.length > 0 ? ((data[0].tugas_selesai / data[0].tugas) * 100) : 0);
        var options = {
            series: [number],
            chart: {
            height: 200,
            type: 'radialBar',
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: '50%',
              },
              dataLabels: {
                show: true,
                value: {
                    show: true,
                    fontSize: '14px',
                    fontFamily: undefined,
                    fontWeight: 400,
                    color: undefined,
                    offsetY: 16,
                    formatter: function (val) {
                     // return '1'  
                    }
                  },
              },
              barLabels: {
                enabled: true,
                offsetX: 0,
                offsetY: 0,
                useSeriesColors: true,
                fontFamily: undefined,
                fontWeight: 600,
                fontSize: '16px',
                formatter: (val) => {
                 // return '1'
                },
                onClick: undefined,
            },
            },
          },
          labels: [ data.length > 0 ? data[0].tugas : 0],
          };
          
          document.querySelector("#chart2").innerHTML = "";
          var chart = new ApexChart(document.querySelector("#chart2"), options);
          chart.render();
    }
     
    const GetChart3 = (data) => {
        var number = (data[0].milestones_selesai / data[0].milestones) * 100;
        var options = {
            
            series: [number],
            chart: {
            height: 200,
            type: 'radialBar',
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: '50%',
              },
              dataLabels: {
                show: true,
                value: {
                    show: true,
                    fontSize: '14px',
                    fontFamily: undefined,
                    fontWeight: 400,
                    color: undefined,
                    offsetY: 16,
                    formatter: function (val) {
                     // return '1'  
                    }
                  },
              },
              barLabels: {
                enabled: true,
                offsetX: 0,
                offsetY: 0,
                useSeriesColors: true,
                fontFamily: undefined,
                fontWeight: 600,
                fontSize: '16px',
                formatter: (val) => {
                 // return '1'
                },
                onClick: undefined,
            },
            },
          },
          labels: [data[0].milestones],
          };
          
          document.querySelector("#chart3").innerHTML = "";
          var chart = new ApexChart(document.querySelector("#chart3"), options);
          chart.render();
    }
    
    const GetChart4 = (data) => {
        var name =['JAM RENCANA','JAM TERPAKAI']
        var data = [data.jam_rencana,data.jam_sebenernya]
    
        var options = {
            series: [{
            data: data
          }],
            chart: {
            type: 'bar',
            height: 250,
            width: "100%",
            toolbar: {
                show: false
              }
          },
          plotOptions: {
            bar: {
              borderRadius: 2,
              //borderRadiusApplication: 'end',
              horizontal: false,
            }
          },
          dataLabels: {
            enabled: true
          },
          xaxis: {
            categories: name,
          }
          };
          document.querySelector("#chart4").innerHTML = "";
          var chart = new ApexChart(document.querySelector("#chart4"), options);
          chart.render();
     }
    
     const GetChart5 = (data) => {
        var dataTask = data.filter(({ task }) => task === "task").map((item) => item.counts);
        var dataRisk = data.filter(({ task }) => task === "risk").map((item) => item.counts);
       // console.log(dataRisk);
    
        var namaKaryawan = data.filter(({ task }) => task === "risk").map((item) => item.nama_client);
        var options = {
            series: [{
            name: 'Tugas',
            data: dataTask
          }, {
            name: 'Resiko',
            data: dataRisk
          }],
            chart: {
            type: 'bar',
            height: 250,
            toolbar: {
              show: false
            }
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              endingShape: 'rounded'
            },
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: namaKaryawan,
          },
          yaxis: {
            title: {
             // text: '$ (thousands)'
            }
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val  
              }
            }
          }
          };
          document.querySelector("#chart5").innerHTML = "";
          var chart = new ApexChart(document.querySelector("#chart5"), options);
          chart.render();
     }
    
     const GetChart6 = (data) => {
      
      var name = data.map((item) => item.milestone_tugas);
      var data =data.map((item) => item.kemajuan);
     
      var options = {
          series: [{
          data: data
        }],
          chart: {
          type: 'bar',
          height: 250,
          width: "100%",
          toolbar: {
              show: false
            },
        },
        // plotOptions: {
        //   bar: {
        //     borderRadius: 2,
        //     //borderRadiusApplication: 'end',
        //     horizontal: false,
        //   }
        // },
        // dataLabels: {
        //   enabled: true
        // },
        xaxis: {
          categories: name,
        },
        };
        document.querySelector("#chart6").innerHTML = "";
        var chart = new ApexChart(document.querySelector("#chart6"), options);
        chart.render();
    }
    
    const GetChart7 = (data)  =>{
      console.log(data)
      var options = {
        series: [
        {
          data: data
        }
      ],
        chart: {
            height: 250,
            width:"100%",
            type: 'rangeBar',
            toolbar: {
                show: true,
                tools:{
                  download:false // <== line to add
                }
              }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          distributed: true,
          dataLabels: {
            hideOverflowingLabels: false
          }
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function(val, opts) {
          var label = opts.w.globals.labels[opts.dataPointIndex]
         // var a = moment(val[0])
         // var b = moment(val[1])
         // var diff = b.diff(a, 'days')
         // return label + ': ' + diff + (diff > 1 ? ' days' : ' day')
          return label  
        },
        style: {
          colors: ['#f3f4f5', '#fff']
        }
      },
      xaxis: {
        type: 'datetime'
      },
      yaxis: {
        show: true
      },
      grid: {
        row: {
          colors: ['#f3f4f5', '#fff'],
          opacity: 1
        }
      }
      };
    
      document.querySelector("#chart7").innerHTML = "";
      var chart = new ApexChart(document.querySelector("#chart7"), options);
      chart.render();
    
         // document.querySelector("#chart7").innerHTML = "";
        // var chart = new ApexChart(document.querySelector("#chart7"), options);
         // chart.render();
    }
    
    const GetChart8 = (data)  =>{
      var name = data.map((item) => item.name);
      var data = data.map((item) => item.data);
    
      var options = {
          series: [{
          data: data
        }],
          chart: {
          type: 'bar',
          height: 250,
          width: "100%",
          toolbar: {
              show: false
            }
        },
        plotOptions: {
          bar: {
            borderRadius: 2,
            //borderRadiusApplication: 'end',
            horizontal: false,
          }
        },
        dataLabels: {
          enabled: true
        },
        xaxis: {
          categories: name,
        }
        };
        document.querySelector("#chart8").innerHTML = "";
        var chart = new ApexChart(document.querySelector("#chart8"), options);
        chart.render();
     
    }
    
    const GetChart9 = (data)  =>{
      Highcharts.chart('chart9', {
        chart: {
            type: 'pie',
            height: 200,
            width: 300,
            custom: {},
            events: {
                render() {
                    const chart = this,
                        series = chart.series[0];
                    let customLabel = chart.options.chart.custom.label;
                  //  const proses = data.data.chart1.find((o) => o.s)
                     const sum = data.reduce((acc, o) => acc + parseInt(o.y), 0);
                     
                    if (!customLabel) {
                        customLabel = chart.options.chart.custom.label =
                            chart.renderer.label('Total Risiko/Isu' + '<br/>' +  sum)
                                .css({
                                    color: '#000',
                                    textAnchor: 'middle',
                                    fontSize: '8px',
                                })
                                .add();
                    }
    
                    const x = series.center[0] + chart.plotLeft,
                        y = series.center[1] + chart.plotTop -
                        (customLabel.attr('height') / 2);
    
                    customLabel.attr({
                        x,
                        y
                    });
                    // Set font size based on chart diameter
                    customLabel.css({
                        fontSize: `${series.center[2] / 12}px`
                    });
                }
            }
        },
        // accessibility: {
        //     point: {
        //         valueSuffix: '%'
        //     }
        // },
        title: {
            text: null
        },
        
        tooltip: {
            pointFormat: '{point.name}: <b>{point.y:.0f}</b>'
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            series: {
                allowPointSelect: true,
                cursor: 'pointer',
                borderRadius: 8,
                dataLabels: [{
                    enabled: true,
                    distance: 20,
                    format: '{point.name}'
                }, {
                    enabled: true,
                    distance: -15,
                    //format: '{point.percentage:.0f}%',
                     format: '{point.y:.0f}',
                    style: {
                        fontSize: '0.9em'
                    }
                }],
                showInLegend: true
            }
        },
        series: [{
         //   name: 'Registrations',
            colorByPoint: true,
            innerSize: '75%',
            data:data
        }]
    });
    }
    
    const GetChart10 = (data) => {
      
      var name = data.map((item) => item.name);
      var data = data.map((item) => item.counts);
    
      var options = {
          series: [{
          data: data
        }],
          chart: {
          type: 'bar',
          height: 200,
          width: "100%",
          toolbar: {
              show: false
            }
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            borderRadiusApplication: 'end',
            horizontal: true,
          }
        },
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          categories: name,
        }
        };
        document.querySelector("#chart10").innerHTML = "";
        var chart = new ApexChart(document.querySelector("#chart10"), options);
        chart.render();
    }
    
    const GetChart11 = (data) => {
      var name = data.map((item) => item.name);
      var data = data.map((item) => item.counts);
    
      var options = {
          series: [{
          data: data
        }],
          chart: {
          type: 'bar',
          height: 200,
          width: "100%",
          toolbar: {
              show: false
            }
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            borderRadiusApplication: 'end',
            //horizontal: true,
          }
        },
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          categories: name,
        }
        };
        document.querySelector("#chart11").innerHTML = "";
        var chart = new ApexChart(document.querySelector("#chart11"), options);
        chart.render();
    }
    
    const GetChart12 = (data)  =>{
        var pengeluaran = data.map((item) => item.data);
        
        var namaProjek = data.map((item) => item.name);
    
        var options = {
            series: [{
                name: 'Level Resiko',
                data: pengeluaran
            } ],
            chart: {
            type: 'bar',
            height: 250,
            stacked: true,
            toolbar: {
              show: false
            },
            zoom: {
              enabled: false
            }
          },
          responsive: [{
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0
              }
            }
          }],
          plotOptions: {
            bar: {
              horizontal: false,
              borderRadius: 10,
              borderRadiusApplication: 'end', // 'around', 'end'
              borderRadiusWhenStacked: 'last', // 'all', 'last'
              dataLabels: {
                total: {
                  enabled: true, // //
                  style: {
                    fontSize: '13px',
                    fontWeight: 900
                  }
                }
              }
            },
          },
          xaxis: {
           // type: 'datetime',
            categories: namaProjek,
          },
          legend: {
            position: 'right',
            offsetY: 40
          },
          fill: {
            opacity: 1
          }
          };
    
         // document.querySelector("#chart12").innerHTML = "";
          //var chart = new ApexChart(document.querySelector("#chart12"), options);
          //chart.render();
    }
    
    const GetChart13 = (data)  =>{
        var pengeluaran = data.map((item) => item.data);
        
        var namaProjek = data.map((item) => item.name);
    
        var options = {
            series: [{
                name: 'Resiko',
                data: pengeluaran
            } ],
            chart: {
            type: 'bar',
            height: 300,
            stacked: true,
            toolbar: {
              show: false
            },
            zoom: {
              enabled: false
            }
          },
          responsive: [{
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0
              }
            }
          }],
          plotOptions: {
            bar: {
              horizontal: false,
              borderRadius: 10,
              borderRadiusApplication: 'end', // 'around', 'end'
              borderRadiusWhenStacked: 'last', // 'all', 'last'
              dataLabels: {
                total: {
                  enabled: true, // //
                  style: {
                    fontSize: '13px',
                    fontWeight: 900
                  }
                }
              }
            },
          },
          xaxis: {
           // type: 'datetime',
            categories: namaProjek,
          },
          legend: {
            position: 'right',
            offsetY: 40
          },
          fill: {
            opacity: 1
          }
          };
    
         // document.querySelector("#chart13").innerHTML = "";
         // var chart = new ApexChart(document.querySelector("#chart13"), options);
         // chart.render();
    }
    
    const GetData = async (id) => {
        try{
          var response = await AxiosFetchData.get(`GetData2/${id}`,"").refreshToken(Navigate,"projectdashboard");
          
          if(response){
            setRoleAccess(response.roleaccess)
            setChartData(response.data);
            if(response.data.chart123.length > 0){
              GetChart1(response.data.chart123);
              GetChart2(response.data.chart123);
              GetChart3(response.data.chart123);
            }
             
              var temp1 = [...response.data.chart6]
       
              GetChart6(temp1.splice(pageChart6,10))
    
              //GetChart6(response.data.chart6);
              temp1 = [...response.data.chart7]
              GetChart7(temp1.splice(pageChart7,10));
             // GetChart7(response.data.chart7);
    
             
              GetChart8(response.data.chart8);
             
              setTugas(response.data.chart123[0].tugas)
              setTugasSelesai(response.data.chart123[0].tugas_selesai)
              setMilestones(response.data.chart123[0].milestones);
              setMilestonesSelesai(response.data.chart123[0].milestones_selesai)
              setAnggaran(response.data.chart123[0].anggaran);
              //setAnggaranTersisa(response.data.project.anggaran_tersisa);
              setAnggaranTersisa(0);
              setFaktur(response.data.chart123[0].faktur);
              setClient(response.data.chart123[0].nama_client)
              setStatus(response.data.chart123[0].status)
              setTanggalSelesai(Helper.GetDateDDMMYYYY(response.data.chart123[0].tanggal_selesai))
              setTanggalMulai(Helper.GetDateDDMMYYYY(response.data.chart123[0].tanggal_mulai));
              setStartEndProject(response.data.startEndProject)
             // console.log(response.data.project.milestones)
          }
        }catch(err){
            setmessage(err.message)
        }
        
        
    }
     
    const handleSelectedProject = (option) => {
        setSelectedOptionProject(option.value);
        GetData(option.value);
    }
    
   
    const Chart6Paging =   (pageNumber) => {
      if(pageNumber < 0){
          return;
      }
     
      var temp = [...chartData.chart6.toSorted()];
      
      if((pageNumber * 10) >= temp.length){
        return;
      }
       
      setPageChart6(pageNumber)
      
      GetChart6(temp.splice((pageNumber * 10)  , 10));
       
    }
    
    const Chart7Paging =   (pageNumber) => {
      if(pageNumber < 0){
          return;
      }
    
      var temp = [...chartData.chart7.toSorted()];
      
      if((pageNumber * 10) >= temp.length){
        return;
      }
       
      setPageChart7(pageNumber)
      
      GetChart7(temp.splice((pageNumber * 10)  , 10));
       
    }

    return {handleSelectedProject,refreshChart,Chart6Paging,Chart7Paging,projectList,tanggalMulai,tanggalSelesai,status,client,
                startEndProject,milestonesSelesai,milestones,tugasSelesai,tugas,anggaran,faktur,pageChart6,pageChart7,selectedOptionProject,setSelectedOptionProject
    }
}